import React, { CSSProperties } from 'react';

import './ToggleSwitch.styles.scss';

export interface ToggleSwitchProps {
    isActive: boolean;
    onToggle: () => any;
    style?: CSSProperties;
    activeLabel?: string;
    inactiveLabel?: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    isActive = false,
    onToggle,
    activeLabel = 'Active',
    inactiveLabel = 'Inactive',
    style = {},
    ...props
}: ToggleSwitchProps) => {
    return (
        <div
            className={`vw-toggle-switch ${isActive ? 'vw-toggle-switch__active' : 'vw-toggle-switch__inactive'}`}
            style={style}
            {...props}
        >
            <div
                className={`vw-toggle-switch__switch ${!isActive ? 'vw-toggle-switch__switch-active' : 'vw-toggle-switch__switch-inactive'}`}
                onClick={() => {
                    if (!isActive) return;
                    onToggle();
                }}
            >
                {activeLabel}
            </div>
            <div
                className={`vw-toggle-switch__switch ${isActive ? 'vw-toggle-switch__switch-active' : 'vw-toggle-switch__switch-inactive'}`}
                onClick={() => {
                    if (isActive) return;
                    onToggle();
                }}
            >
                {inactiveLabel}
            </div>
        </div>
    );
};

export default ToggleSwitch;
